import React from "react";
import styled from 'styled-components';
import { mediaQueries } from "../shared/config";

const Box = styled.a`
    display: flex;
    text-decoration: none;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 150px;
    background-color: white;
    color: black;
    &:hover{
        box-shadow: 5px 5px 5px rgba(0,0,0);
    }
    ${mediaQueries.tablet} {
      min-height: 150px;
    }
`;

const Text = styled.div`
    flex: 1 280px;
`;

const News = styled.div`
    word-wrap: break-word;
    font-family: Optima;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;

    /* identical to box height */
    align-items: center;
    text-transform: uppercase;
    padding: 1px 10px 1px 10px;

    color: #1B1B1B
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;  
    overflow: hidden;
    ${mediaQueries.tablet} {
      font-size: 12px;
      padding: 1px 10px 1px 10px;
    }
    ${mediaQueries.mobile} {
        font-size: 12px;
        padding: 1px 10px 1px 10px;
      }
`;

const Author = styled.div`
font-family: Optima;
font-style: normal;
font-weight: normal;
font-size: 12px;
line-height: 17px;
/* identical to box height */

display: flex;
align-items: center;
text-transform: uppercase;

color: #1B1B1B;
padding: 10px;
${mediaQueries.mobile} {
    font-size: 9px;
}
`;

const Image = styled.img`
  flex: 1 330px;
  height: 150px;
  width: 50%;
  object-fit: cover;
  background-image: url(${(props) => props.src});
  background-position: center;
  background-size: cover;
  border-left-width: 7px;
  border-left-style: solid;
  border-left-color: ${(props) => props.color};
`;

const NewsAnchor = styled.a`
    color: black;
    text-decoration: none;
`

function ArticleBox(props) {
    let text = props.text;
    let author = props.author;
    let image = props.image;

    console.log("hello");

    return (
            <Box href={props.url}> 
                <Text>
                    <NewsAnchor href={props.url}>
                    <News> {text} </News>
                    </NewsAnchor>
                    <Author> {author} </Author>
                </Text>
                    <Image image = {image} src={image} alt=""/>
                      
            </Box>
    );
}
export default ArticleBox